import React from 'react'

import './about_me.css'
export default function AboutMe() {
  return (
    <div className="aboutMeContainer">
      <i><span> 🚧</span></i>
      <p>This page is under construction...</p>
    </div>
  )
}